import * as React from "react";
import moment from 'moment'
import { useLocalize } from "@/modules/shared/context/localize/LocalizeContext";
import { RepeatableSection } from "../components/RepeatableSection";

import { DriverQualificationsType } from "@/app/constants/driverQualificationsType";

import { DriverWorkYearsPeriods } from "@/app/constants/configuration/driverWorkYearsPeriods";

import { PolishMinimumWageConfigurationExpandableItemModel, PolishMinimumWageConfigurationModel } from "@/app/models/configuration/minimumWage/polishMinimumWageConfigurationModel";

type Props = {
    driverWorkYears?: DriverWorkYearsPeriods[]
    allowedCurrencies?: string[]
    qualificationTypes?: DriverQualificationsType[]
    state: PolishMinimumWageConfigurationModel
    setState: React.Dispatch<React.SetStateAction<PolishMinimumWageConfigurationModel>>
}

const DRIVER_WORK_YEARS_PERIODS_DEFAULT = [
  DriverWorkYearsPeriods.All,
  DriverWorkYearsPeriods.None,
]

const QUALIFICATION_TYPES_DEFAULT = [
    DriverQualificationsType.NotSet,
]

const pln = {id: 1, code: "PLN", name: "złoty"}

export const PolishMinMonthlyRateExpandableItemSection = ({
    allowedCurrencies,
    driverWorkYears,
    qualificationTypes,
    state,
    setState,
}: Props) => {
    const { t } = useLocalize()

    return (
        <RepeatableSection<PolishMinimumWageConfigurationExpandableItemModel>
            title={t('configuration.minimumWages.minimalMonthRateName')}
            newRow={() => ({
                configurationValueId: 0,
                rateValue: 0,
                rateDate: moment(),
                isNew: true,
            })}
            columns={[
                {
                    order: 1,
                    label: t('configuration-minimumWage.from-date'),
                    type: "date",
                    get: (r) => r.rateDate,
                    set: (r, v) => ({ ...r, rateDate: moment(v) }),
                },
                {
                    order: 4,
                    label: t('common.amount'),
                    type: "price",
                    get: (r) => r.rateValue,
                    set: (r, v: number) => ({ ...r, rateValue: Number(v) }),
                },
                {
                    order: 5,
                    label: t("configuration.countries.currency"),
                    type: "select", //"currency",
                    options: [pln].filter(c => Array.isArray(allowedCurrencies) ? allowedCurrencies.includes(c.code) : true).map((c) => ({ label: `${c.code} - ${c.name}`, value: c.code })).sort((a, b) => a.label.localeCompare(b.label)),
                    get: (r) => pln.code,
                    set: (r, v) => {
                        const selected = [pln].find(c => c.code === v)
                        return ({ ...r, rateCurrency: selected })
                    }
                },
            ]}
            canAddRow={true}
            rows={state.expandableItems}
            setRows={(next) => {
                setState(prev => {
                    const current = prev.expandableItems;
                    const nextRows = typeof next === "function" ? (next as (p: typeof current) => typeof current)(current) : next;
                    return { ...prev, expandableItems: nextRows };
                });
            }}
            sortRows={(a, b) => {
                const da = moment(a.rateDate)
                const db = moment(b.rateDate)
                const ta = da.valueOf()
                const tb = db.valueOf()
                if (ta === tb) return 0
                return ta > tb ? -1 : 1
            }}
        />
    )
}
